import React from "react";
import "./ProgressBar.css";
import Icons from "../../Assets/Icons";
import { useTranslation } from "react-i18next";

const ProgressBar = ({ steps, currentStep, enabledSteps, onStepChange }) => {
  const {t} = useTranslation()
  const handleStepClick = (index) => {
    if (enabledSteps.includes(index + 1)) {
      onStepChange(index + 1);
    }
  };

  return (
    <div className="progress-container">
      {steps.map((step, index) => (
        <div
          key={index}
          className={`step ${index + 1 <= currentStep ? "active" : ""} ${enabledSteps.includes(index + 1) ? "enabled" : "disabled"}`}
          onClick={() => handleStepClick(index)}>
          <div className="circle">{index + 1 <= currentStep ? <img src={Icons.step} /> : <img src={Icons.stepChecked} />}</div>
          <div className="label">{t(step)}</div>
        </div>
      ))}
    </div>
  );
};

export default ProgressBar;
